import React from 'react';

const SynchronizeIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0L5.33333 2.66667L8 5.33333V3.33333C10.5727 3.33333 12.6667 5.42667 12.6667 8C12.6667 8.58667 12.5528 9.14673 12.3542 9.66406L13.3646 10.6732C13.7679 9.86718 14 8.96133 14 8C14 4.692 11.3087 2 8 2V0ZM2.63542 5.32682C2.23208 6.13282 2 7.03867 2 8C2 11.308 4.69133 14 8 14V16L10.6667 13.3333L8 10.6667V12.6667C5.42733 12.6667 3.33333 10.5733 3.33333 8C3.33333 7.41333 3.44717 6.85327 3.64583 6.33594L2.63542 5.32682Z" fill="currentColor"/>
    </svg>
  );
};

export default SynchronizeIcon;
